export default __webpack_public_path__ + "static/media/anpc-sol.7aa3136b.svg";